(() => {
  const manualKey = 'bpd-country-manually-selected';
  const automaticKey = 'bpd-country-auto-initialized';
  let manualSelection = false;
  const readFlag = (storage, key) => {
    try { return window[storage].getItem(key) === 'true'; } catch { return false; }
  };
  const setFlag = (storage, key) => {
    try { window[storage].setItem(key, 'true'); return true; } catch { return false; }
  };
  const setReturnPath = (form) => {
    const field = form.querySelector('[name="return_to"]');
    if (field) field.value = location.pathname + location.search + location.hash;
  };
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();

  if (!customElements.get('bpd-shipping-destination')) {
    customElements.define('bpd-shipping-destination', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.details = this.querySelector('details');
        if (!this.details) return;
        this.summary = this.querySelector('summary');
        this.search = this.querySelector('input[type="search"]');
        this.form = this.querySelector('form');
        this.status = this.querySelector('[role="status"]');
        this.items = Array.from(this.querySelectorAll('li'));
        this.querySelector('.bpd-destination__search').hidden = false;
        this.summary.setAttribute('role', 'button');
        this.summary.setAttribute('aria-expanded', 'false');
        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            document.querySelectorAll('bpd-shipping-destination').forEach((other) => {
              if (other !== this && other.details) other.details.open = false;
            });
            this.search.focus();
          }
        });
        this.querySelector('[data-destination-close]').addEventListener('click', () => this.close());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            const notice = event.target.closest('.bpd-destination__unavailable[open]');
            if (notice) {
              event.preventDefault();
              event.stopPropagation();
              this.escapeHandled = true;
              notice.open = false;
              notice.querySelector('summary').focus();
              return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.escapeHandled = true;
            this.close();
          }
          // Enter in search must never submit a destination accidentally.
          if (event.target === this.search && event.key === 'Enter') event.preventDefault();
        });
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape' && this.escapeHandled) {
            event.stopPropagation();
            this.escapeHandled = false;
          }
        });
        this.addEventListener('change', (event) => event.stopPropagation());
        this.search.addEventListener('input', () => {
          const query = normalize(this.search.value);
          let count = 0;
          this.items.forEach((item) => {
            const matches = normalize(item.dataset.countryName).includes(query) || normalize(item.dataset.countryCode) === query;
            item.hidden = !matches;
            if (matches) count++;
            if (!matches) item.querySelectorAll('details').forEach((detail) => { detail.open = false; });
          });
          this.status.textContent = count ? `${count} ${count === 1 ? 'country' : 'countries'}` : 'No countries found';
        });
        this.form.addEventListener('submit', (event) => {
          if (!event.submitter || event.submitter.name !== 'country_code') {
            event.preventDefault();
            return;
          }
          manualSelection = true;
          setFlag('localStorage', manualKey);
          setFlag('sessionStorage', automaticKey);
          setReturnPath(this.form);
          if (this.closest('cart-drawer')) {
            try { sessionStorage.setItem('bpd-destination-reopen-cart', String(Date.now())); } catch {}
          }
          this.status.textContent = 'Updating shipping destination…';
          // Allow Shopify's native POST, including the clicked country_code button.
        });
        this.outsideClick = (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        };
        document.addEventListener('click', this.outsideClick);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.outsideClick);
        this.bound = false;
      }
      close() {
        this.details.open = false;
        this.summary.focus();
      }
    });
  }

  // Preserve the existing BPD first-visit recommendation flow and preference keys.
  // Suggestions, available destinations and all resulting prices remain Shopify-owned.
  async function autoSetCountryOnFirstVisit() {
    if (readFlag('localStorage', manualKey) || readFlag('sessionStorage', automaticKey)) return;
    const control = document.querySelector('.bpd-destination--footer');
    const form = control?.querySelector('form');
    if (!form) return;
    const currentCountry = control.dataset.country;
    try {
      const response = await fetch(window.Shopify.routes.root +
        'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
        encodeURIComponent(currentCountry), { credentials: 'same-origin' });
      if (!response.ok) return;
      const data = await response.json();
      const suggested = data?.detected_values?.country?.handle || data?.suggestions?.[0]?.parts?.country?.handle;
      // A manual choice or an open country picker wins over an in-flight recommendation.
      if (manualSelection || readFlag('localStorage', manualKey)) return;
      if (document.querySelector('bpd-shipping-destination details[open]')) return;
      // Without working session storage, skip automatic POSTs to prevent reload loops.
      if (!setFlag('sessionStorage', automaticKey)) return;
      const match = Array.from(form.querySelectorAll('button[name="country_code"]'))
        .find((button) => button.value.toUpperCase() === suggested?.toUpperCase());
      if (!match || match.value.toUpperCase() === currentCountry.toUpperCase()) return;
      const country = document.createElement('input');
      country.type = 'hidden';
      country.name = 'country_code';
      country.value = match.value;
      form.append(country);
      setReturnPath(form);
      form.submit();
    } catch (error) {
      console.warn('Country auto-detect unavailable:', error);
    }
  }
  // Reopen only after an explicit destination change made inside the cart drawer.
  // This never opens a drawer on a first visit.
  window.addEventListener('load', () => {
    try {
      const changedAt = Number(sessionStorage.getItem('bpd-destination-reopen-cart'));
      sessionStorage.removeItem('bpd-destination-reopen-cart');
      if (changedAt && Date.now() - changedAt < 120000) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(document.querySelector('[data-bpd-cart-toggle]'));
      }
    } catch {}
  }, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSetCountryOnFirstVisit, { once: true });
  } else {
    autoSetCountryOnFirstVisit();
  }
})();
